import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-webhook-table',
  templateUrl: './webhook-table.component.html',
  styleUrl: './webhook-table.component.scss',
})
export class WebhookTableComponent {
  @Input() data: any;
  @Input() action: ((id: string| number) => void)  = ()=>{};
  @Input() loading: boolean | undefined;
  @Input() processLoading: boolean = false;
  constructor(){
    // console.log(this.data)
  }
}
